import type { AgentTaskGroup } from './canvas-types';

/** Keep failed attempts visible in process details, but don't call a recovered save a failed request. */
export function taskProgressOutcome(groups: readonly AgentTaskGroup[]) {
  const steps = groups.flatMap(group => group.steps);
  const recovered = new Set(steps.filter((step, index) => step.status === 'error'
    && step.toolName === 'update_identity'
    // This validation rejects the call before any field is selected or written.
    // Other failures may concern a different entity/field and must stay failed.
    && /Choose one edit selector/i.test(step.summary ?? step.error ?? '')
    && steps.slice(index + 1).some(later => later.toolName === step.toolName && later.status === 'success')).map(step => step.id));
  const unresolved = steps.filter(step => !recovered.has(step.id));
  const failed = unresolved.some(step => step.status === 'error')
    || groups.some(group => group.status === 'failed' && (!group.steps.some(step => recovered.has(step.id))
      || group.steps.some(step => step.status !== 'success' && !recovered.has(step.id))));
  return { steps, recovered, failed, total: unresolved.length, completed: unresolved.filter(step => step.status === 'success').length,
    finished: unresolved.length > 0 && unresolved.every(step => step.status === 'success') };
}
